import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import NotificationComponent from '/@/components/notifications';
import { markAllNotificationsAsRead, markAsClicked, markAsRead, useNotifications } from '/@/hooks/notifications';
import { getSessionCountry } from '/@/store/session/selectors';
import { trackEvent } from '/@/store/tracking';

const Notifications = () => {
    const country = useSelector(getSessionCountry);
    const dispatch = useDispatch();

    const { data: notifications } = useNotifications({ country: country });
    const readedNotifications = notifications ? notifications.readedNotifications : [];
    const unreadedNotifications = notifications ? notifications.unreadedNotifications : [];

    const markNotificationAsRead = async (id) => {
        dispatch(trackEvent({ key: 'notifications.markAsRead' }));
        await markAsRead({ id, country });
    };

    const markNotificationAsClicked = async (id) => {
        dispatch(trackEvent({ key: 'notifications.markAsClicked' }));
        await markAsClicked({ id, country });
    };

    const markAllAsRead = async () => {
        dispatch(trackEvent({ key: 'notifications.markAsRead', type: 'all' }));
        await markAllNotificationsAsRead({ unreadedNotifications, country });
    };

    return (
        <Container disableGutters maxWidth='md'>
            <Grid
                className='mp-mask'
                sx={{
                    my: { md: 4 },
                    border: '1px solid #E1E1E1',
                }}
            >
                <NotificationComponent
                    unreadedNotifications={unreadedNotifications}
                    readedNotifications={readedNotifications}
                    handleClose={false}
                    markAllAsRead={markAllAsRead}
                    markNotificationAsRead={markNotificationAsRead}
                    markNotificationAsClicked={markNotificationAsClicked}
                    seeAllView
                />
            </Grid>
        </Container>
    );
};

export default Notifications;
